import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewChecked } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { AllDropdownKeys, UrlSegments } from '../../../jurisdiction/jurisdiction.constants';
import { LookupOptionsData } from '../../../jurisdiction/jurisdiction.domain';
import { CommonService } from '../../../services/common.service';
import { AddressAndPersonalData } from '../../../+grid-application-shared/entities/personal-data/addressAndPersonalData';
import { RegepOrderProcess } from 'src/app/+regep/entities/regep-order-process';
import { RegepProcessStatus } from 'src/app/+regep/entities/enums/regepProcessStatus';
import { UserService } from 'src/app/services/user.service';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { CommunicationService } from 'src/app/services/communication.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-person-data-fields',
  templateUrl: './person-data-fields.component.html',
  styleUrls: ['./person-data-fields.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class PersonDataFieldsComponent extends DestroyableComponent implements OnInit, AfterViewChecked {
  @Input() personData: AddressAndPersonalData;
  @Input() formName: string;
  @Input() hasEmail: boolean;
  @Input() hasCompany: boolean;
  @Input() isDetailsView: boolean;
  @Input() appNotFinished: boolean;
  @Input() isDisabled: boolean;
  @Input() useFieldOpacity: boolean = false;
  @Output() formChangedEvent = new EventEmitter<any>();

  @ViewChild('addressData', { read: NgForm }) addressData: any;

  titleKey: string;
  allTitles: LookupOptionsData[];
  showResendOwnerEmailBtn = false;
  disableResendOwnerEmailBtn = false;
  applicationId: number;

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private userService: UserService,
    private communicationService: CommunicationService,
    private errorService: ErrorService
  ) {
    super();
  }

  ngOnInit(): void {
    this.applicationId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.titleKey = AllDropdownKeys.Title;
    this.allTitles = this.commonService.getDropdownData(this.titleKey);
    if (this.personData) {
      this.personData.country = 'Deutschland';
    }
    if (this.isDetailsView) {
      this.preventLeak(
        this.communicationService.getData<RegepOrderProcess>(`${UrlSegments.RegepOrderProcessByApplication}${this.applicationId}`)
      )
        .pipe(filter(orderProcess => !!orderProcess))
        .subscribe(orderProcess => {
          this.showResendOwnerEmailBtn = orderProcess?.status === RegepProcessStatus.EngineeringOk && this.isInternalUser;
        });
    }
  }

  ngAfterViewChecked(): void {
    this.formChanged();
  }

  public formChanged(): void {
    this.formChangedEvent.emit({
      name: this.formName,
      state: this.addressData.valid || this.addressData.form.status === 'DISABLED',
      dirty: this.addressData.dirty,
    });
  }

  public get isInternalUser(): boolean {
    return this.userService.isUserModeratorRole();
  }

  public disabledSectionStyle(): string {
    return this.useFieldOpacity ? 'disable-section' : '';
  }

  public resendOwnerEmail(): void {
    if (!this.showResendOwnerEmailBtn) return;

    this.disableResendOwnerEmailBtn = true;
    this.preventLeak(this.communicationService.postData(`${UrlSegments.RegepResendOwnerEmail}${this.applicationId}`, {})).subscribe(
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }
}
